import {
  API_PASSWORD_FACTURA,
  API_USUARIO_FACTURA,
  BASE_URL_FACTURA,
  X_API_KEY,
} from "../_constants/urlConstants";
const { buildErrResponse } = require("../_utils/utils");
const { default: Axios } = require("axios");

/** TODO call api key before send receipt*/
const params = new URLSearchParams();

export const FacturaDigitalService = {
  getApiKey,
  getAccountBalance,
  createCFDI,
  sendEmail,
};

function getApiKey() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_FACTURA}/v5/account/authorize`, {
      headers: {
        "api-usuario": API_USUARIO_FACTURA,
        "api-password": API_PASSWORD_FACTURA,
      },
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAccountBalance() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_FACTURA}/v5/account/balance`, {
      headers: {
        "x-api-key": X_API_KEY,
      },
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function createCFDI(cfdiBody) {
  params.append("json", cfdiBody);
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_FACTURA}/v5/invoice/create`, params, {
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function sendEmail(uuid, recipient, message, cbb) {
  console.log('uuid in SERVICE', uuid);
  console.log('recipient in service', recipient);
  console.log('message in SERVICE', message);
  console.log('cbb in SERVICE', cbb);

  const headers = {
    "X-Api-Key": X_API_KEY,
    "Content-Type": "application/x-www-form-urlencoded",
    "uuid": uuid,
    "recipient": recipient,
    "message": message,
    "cbb": cbb
  }
  return new Promise((resolve, reject) => {
    Axios.post(
      `${BASE_URL_FACTURA}/v5/invoice/send`, null,
      {
        headers
      }
    )
      .then((resp) => {
        console.log('resp', resp)
        resolve(resp);
      })
      .catch((err) => {
        console.log('error', err)
        reject(buildErrResponse(err));
      });
  });
}
